import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import { useOutletContext, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearUploadedDocument, toggleFullView } from "../../store/reducers/uploadDocumentSlice";
import PdfMiniSidenav from './pdfMiniSidenav';
import PDFPreview from './pdfminipreview';
import { apiEndpoint } from '../../urls';
import { esignToolApi } from '../../services/esignApi';
import PDFTileView from './templateTilesView';
import SelectedTemplatePdfPreview from './selectedTemplatePreview';
import { uploadDocument } from '../../store/reducers/uploadDocumentSlice';
import Loader from '../Loader';
import { useLogger } from '../../hooks/useLogger';

export default function ChooseTemplate() {
  const logEvent = useLogger();
  const { open, openSideBar } = useOutletContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const [documents, setDocuments] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
      fetchAllDocuments();
    }, []);
  
    const fetchAllDocuments = async () => {
      setLoader(true)
      try {
        const response = await esignToolApi.getTemplates();
        setLoader(false)
        if (response) {
          console.log(response)
          setDocuments(response.data);
        }
      } catch (error) {
        setLoader(false)
        console.error("Error fetching data:", error);
      }
    };
    function uploadFileFromUrl() {
      logEvent('Clicked', 'Upload selected template', 'New-eSign/choose-template');
        fetch(selectedPdf?.file_url)
          .then(response => response.blob())
          .then(blob => {
              const file = new File([blob], "uploadedFile.pdf", { type: blob.type });
              dispatch(uploadDocument({ token: pdfEditortoken?.access, file, fileName: selectedPdf?.name }));
              navigate("/esign/new-esign", { replace: true });
          })
          .catch(error => console.error("Error fetching file:", error));
    }

  return (<>
    <Box
      sx={{
        flexGrow: 1,
        p: "24px 0 18px 35px",
        width: "100%",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        background: "#f9f9f9",
        gap: 3
      }} 
    >
        <Box
            mt={10}
            style={{
                borderRadius: '12px',
                textAlign: 'center',
                background: '#fff',
                width: "calc(100% - 32px)",
                height: "calc(100% - 84px)",
                marginLeft: open ? "" : "1em",
                display: "flex",
                padding: "30px",
            }}
        >
            <Box sx={{ width: "60%", height: '100%', display: "flex", padding: "0 2em", flexDirection: "column" }}>
                <Box sx={{ display: "flex", cursor: "pointer" }} onClick={() => {logEvent('Click', 'Click on Back on choose template', 'new-esign/choose-template'); navigate("/esign/new-esign", { replace: true })}} >
                    <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L2 10L9 2" stroke="#2556AB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                      {selectedPdf?.name}
                    </Typography>
                </Box>
                <Box sx={{ borderRadius: '12px', textAlign: 'center', background: '#fff', width: "100%", display: "flex", height: "calc(100% - 22px)", alignItems: "center", justifyContent: "space-between", flexDirection: "column", pt: "30px" }} >
                    {selectedPdf && <SelectedTemplatePdfPreview pdfUrl={selectedPdf.file_url} />}
                </Box>
            </Box>
            <Box sx={{ width: "40%", height: '100%', display: "flex", flexDirection: "column" }}>
                <Box sx={{ display: "flex",}} >
                    <Typography noWrap component="p" sx={{ fontSize: '22px', fontWeight: 700, lineHeight: '100%', color: "#1D1D1D" }}>Choose Templates </Typography>
                </Box>
                <Box sx={{ borderRadius: '12px', textAlign: 'center', background: '#fff', width: "100%", display: "flex", height: "calc(100% - 22px)", pt: "30px" }} >
                    <PDFTileView documents={documents} setSelectedPdf={setSelectedPdf} />
                </Box>
                <Box sx={{display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <Button variant="contained" sx={{ width: '154px', height: 45, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", boxShadow: "none", fontWeight: "500",}} onClick={uploadFileFromUrl} >
                        Next
                    </Button>
                </Box>
                
            </Box>
        </Box>        
    </Box>
    {loader && <Loader />}
    </>
  );
}
